import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import { memberPortal } from "../member-portal";
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";
import { DataTable } from 'datatables';
require('datatables.net');
require('datatablesResponsive');

export class memberFamilyPool{
    private FamilyPool:any   = $('#family_pool_mob');
    $scope: any = $('#family_pool_mob');
    private memberBase:any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	familyPoolData:any
    familyPoolDatabenID:any

    populateFamilyData():any{
        let _self = this;
        //let familyTab = $("[href='#family_pool']");
        let familyurl:any;
        var familyList= $.Deferred();
       // familyTab.click(function(){
            if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                familyurl = '/dummy-data/memberfamilypool.json';
            }else{
                familyurl = "/bin/services/new/getFFPoolDtls";
            }
            _self.bookingformcommon.preloader();
            // fetch family members
            $.get(familyurl)
            .done((data: any) => {
                if (typeof data === 'string') {
                    data = JSON.parse(data);
                    console.log(data);
                }
                familyList.resolve(data);
                // _self.familyPoolDatabenID = data;
                _self.bookingformcommon.preloaderClose();
                _self.familyPoolData = data;
                // _self.familyPoolDatabenID = data.benfId;
                $("#family-pool--input-details-beneficiary-id").val(data.benfId);
                $("#family-pool--input-details-start-date").val(data.benfStrtDate);
                $("#family-pool--input-details-end-date").val(data.benfEndDate);
                $("#family-pool--input-details-size").val(data.size);
                $("#family-pool--input-details-pool-name").val(data.poolName);
                // $("#family-pool--input-details-size").val(data.contributorList[0].loginID);

            })
            .fail((error: any) => {
                familyList.reject(error)
            });
      //  })
        
       

        $.when(familyList).done(function(family: any){
            $('.members-family-pool .number-of-person').html(family.contributorList.length);
            if(family.contributorList.length < 8 && family.ageLimit == "true" && family.isBeneficiary=="true"){
                $('.click-nom-tab').removeClass('hide-class');
                $('#delete-all-button').removeClass('hide-class');
            }else{
                $('.click-nom-tab').addClass('hide-class');
                $('#delete-all-button').addClass('hide-class');
            }
            let familyTable = $('#family-pool-table')

            if(family.contributorList.length === 0 && family.ageLimit == "true"){
                familyTable.hide();
                $('.members-family-pool').addClass('hide-class');
                $('.family-pool-input').addClass('hide-class');
                $('.description-ff').addClass('hide-class');
                $('.no-ff-dispay').removeClass('hide-class');
                $('.ff-age-limit').addClass('hide-class');
            }else if(family.ageLimit == "false"){
                familyTable.hide();
                $('.members-family-pool').addClass('hide-class');
                $('.family-pool-input').addClass('hide-class');
                $('.description-ff').addClass('hide-class');
                $('.ff-age-limit').removeClass('hide-class');
                $('.no-ff-dispay').addClass('hide-class');
            }else{
                _self.populateTable(familyTable,family);
                // $('.no-ff-dispay').addClass('hide-col');
            }
            
           
        })
        
    }
    // changeToNominee():any{
    //     let nomineeTab = $("[href='#nominee']");
    //     nomineeTab.click(function(){
    //         $(this).parents('ul').addClass('mytrav-inactive');
    //     });
    // };
    populateTable(tableElm:any, tableData:any):any{
        let _self = this;

        tableElm.DataTable({
            data: tableData.contributorList,
            info:false,
            bLengthChange: false,
            paging:false,
            ordering:false,
            responsive: false,
            "columns": [
                {
                    "data": function(row:any, type:string, val:any, meta:string ){
                        return row['contributorId'];
                    }
                },
                {
                    "data": function(row:any, type:string, val:any, meta:string){
                        return row['relationship'];
                    }
                },
                {
                    "data": function(row:any, type:string, val:any, meta:string){
                        return row['percentage'];
                    }
                },
                {
                    "data": function(row:any, type:string, val:any, meta:string){
                        return row['contributoStrtDate'];
                    }
                },
                {
                    "data": function(row:any, type:string, val:any, meta:string){
                        return row['contributoEndDate'];
                    }
                },
                {
                    "data": function(row:any, type:string, val:any, meta:string){
                        return row['status'];
                    }
                },
                {
                    "data": function(row:any, type:string, val:any, meta:string){
                        if((tableData.isBeneficiary == 'false' && tableData.isContributor == 'true') && row['loginID'] == 'true'){
                            //$('#delete-all-button').addClass('hide-class');
                            if(row['endDateCheck'] == 'true'){
                                return `<a href="" id="delete-family-row-details" class="delete-family-row-details open-popup-link" style="color: grey;pointer-events:none;background-color: darkgray;text-decoration: none;margin-right: 10px;display:none;"> <img src="/content/dam/mas/enrich/icons/Leave_from_pool.svg" style="font-size: 21px;"></img></a>`
                            }else{
                                return `<a href="" id="delete-family-row-details" class="delete-family-row-details open-popup-link" style="color: red;text-decoration: none;margin-right: 10px;"> <img src="/content/dam/mas/enrich/icons/Leave_from_pool.svg" style="font-size: 21px;"></img></a>`
                            }          
                    }else if(tableData.isBeneficiary == 'true'){
                        if(row['endDateCheck'] == 'true'){
                            return `<a href="" id="delete-family-row-details" class="delete-family-row-details open-popup-link" style="color: grey;pointer-events:none;background-color: darkgray;text-decoration: none;margin-right: 10px;display:none;"> <img src="/content/dam/mas/enrich/icons/Remove_contributor.svg" style="font-size: 21px;"></img></a>`
                        }else{
                            return `<a href="" id="delete-family-row-details" class="delete-family-row-details open-popup-link" style=" color: red;text-decoration: none;margin-right: 10px;"> <img src="/content/dam/mas/enrich/icons/Remove_contributor.svg" style="font-size: 21px;"></img></a>`
                        }         
                    }else{
                        return `<a href="" id="delete-family-row-details" class="delete-family-row-details open-popup-link disabled" style="color: grey;pointer-events:none;background-color: darkgray;text-decoration: none;margin-right: 10px;display:none;"><img src="/content/dam/mas/enrich/icons/Leave_from_pool.svg" style="font-size: 21px;"></img></a>`
                    }
                    }
                },

            ],
            initComplete: function(settings:any, json:any) {
                _self.handleFamilyRowPopup();
            }
        });
    };
    handleFamilyRowPopup():any{
        let _self = this;
        $("#family-pool-table").on('click','.delete-family-row-details',function($instance:any) {
            $instance.preventDefault();
            var currentRow=$(this).closest("tr");
            var contributionColID=currentRow.find("td:eq(0)").html();
            
            $.magnificPopup.open({
                    items: {
                        src: ' #family-delete-row-popup'
                },
                type: 'inline',
                midClick: true,
                enableEscapeKey: false,
                showCloseBtn: false,
                closeOnBgClick: false,
                modal: true,
                callbacks: {
                    open: function() {
                        var $content = $(this.content);
                        
                        $content.on('click', '.msg-btn-confirm', function() {
                            $.magnificPopup.close();
                            //_self.handleSuccessMessage();
                            // currentRow.addClass("hideClass")
                            _self.bookingformcommon.preloader();
                            let data={
                                contributionID :contributionColID
                            }
                            $.ajax({
                                type: 'POST',//Change to POST if required
                                url: "/bin/services/new/removeOrDelIndivFFPool",
                                data: data,
                                success: function(msg:any) {						       
                                    _self.bookingformcommon.preloaderClose();
                                    if (msg != "") {
                                        var json = msg;
                                        if (typeof msg === 'string') {
                                            json=JSON.parse(msg);
                                        }
                                        if (json.processCode === "OK") {
                                            $("#delete-succ-msg").html(json.succMsg);
                                            $("#member-family-pool .error-validation").html("");
					                        $("#member-family-pool .error-validation").css("display", "none");
					                        $("#member-family-pool .error-validation").removeClass('mandatory-text');
                                            _self.handleSuccessMessage();
                                        }else{
                                            $("#member-family-pool .error-validation").html(json.succMsg);
					                        $("#member-family-pool .error-validation").css("display", "block");
                                            $("#member-family-pool .error-validation").css("color", "#ed1c24");
					                        $("#member-family-pool .error-validation").addClass('mandatory-text');
                                        }
                                    }
                                },

                            });

                        });
        
                        $content.on('click', '.msg-btn-cancel', function() {
                            $.magnificPopup.close();
                        
                        });
                    }
                }
            }, 0);
        });
    };
    
   
    handleFamilyDeleteAllPopup():any{
        let _self = this;
        $("#delete-all-button").on('click',function($instance:any) {
            $instance.preventDefault();
            $.magnificPopup.open({
                    items: {
                        src: ' #family-delete-all-popup'
                },
                type: 'inline',
                midClick: true,
                enableEscapeKey: false,
                showCloseBtn: false,
                closeOnBgClick: false,
                modal: true,
                callbacks: {
                    open: function() {
                        var $content = $(this.content);
                       
                        $content.on('click', '.msg-btn-confirm', function() {
                            $.magnificPopup.close();
                            // $('#family-pool-table tbody').addClass('hideClass');
                            let contributionColIDarray:any = [];
                           // let action = 'deleteAll';
                            _self.bookingformcommon.preloader();
                            $('#family-pool-table tbody tr').each(function() {
                                let dataID = $(this).find("td:eq(0)").html();
                                 contributionColIDarray.push(dataID);
                              });
                              let data={
                                'action' :'deleteAll'
                            }
                            console.log(contributionColIDarray);
                            $.ajax({
                                type: 'POST',//Change to POST if required
                                url: "/bin/services/new/removeOrDelIndivFFPool",
                                data: data,
                                success: function(msg:any) {						       
                                    _self.bookingformcommon.preloaderClose();
                                    if (msg != "") {
                                        var json = msg;
                                        if (typeof msg === 'string') {
                                            json=JSON.parse(msg);
                                        }
                                        if (json.processCode === "OK") {
                                            $("#delete-succ-msg").html(json.succMsg);
                                            $("#member-family-pool .error-validation").html("");
					                        $("#member-family-pool .error-validation").css("display", "none");
					                        $("#member-family-pool .error-validation").removeClass('mandatory-text');
                                            _self.handleSuccessMessage();
                                        }else{
                                            $("#member-family-pool .error-validation").html(json.succMsg);
					                        $("#member-family-pool .error-validation").css("display", "block");
                                            $("#member-family-pool .error-validation").css("color", "#ed1c24");
					                        $("#member-family-pool .error-validation").addClass('mandatory-text');
                                        }

                                    }
                                },

                            });
                        });
        
                        $content.on('click', '.msg-btn-cancel', function() {
                            $.magnificPopup.close();
                        
                        });
                    }
                }
            }, 0);
        });
    };
    handleSuccessMessage():any{
        let _self = this;
        _self.bookingformcommon.preloader();
        $.magnificPopup.open({
            items: {
                src: '  #family-success-message'
        },
        type: 'inline',
        midClick: true,
        enableEscapeKey: false,
        showCloseBtn: false,
        closeOnBgClick: false,
        modal: true,
        callbacks: {
            open: function() {
                var $content = $(this.content);
                _self.bookingformcommon.preloaderClose();
                $content.on('click', '.msg-btn-close', function() {
                    $.magnificPopup.close();
                    location.reload();
                });

               
            }
        }
    }, 0);

    };
    
}


let scope:Element = document.querySelector('#family_pool_mob');

if (scope) {
	try {
        let memberfamilypool = new memberFamilyPool();
        memberfamilypool.populateFamilyData();
        memberfamilypool.handleFamilyDeleteAllPopup();
        memberfamilypool.handleFamilyRowPopup();
       
	} catch(e) {console.error(e);}
}